<template>
  <m-single-product-wrapper @product="dataReady" :product-link="productLink">
    <b-container slot-scope="{product}" class="pt-5" fluid>
      <b-container class="border single-product-background-1 rounded pb-4">
        <b-row>
          <h2 class="h4 pt-3 pr-3"> {{ product.name }}
            <m-edit-item-1 :item-params="[product.raw_link]"/>
          </h2>
        </b-row>
        <b-row>
          <b-col cols="12" sm="12" md="3">
            <hr class=""/>
            دسته بندی:

            <span v-for="(category, index) in product.category" :key="index">
            <router-link class="text-decoration-none text-secondary"
                         :to="categoryLink ? { name: 'Products', query: { page: 1, category: category.id }, } : '#'">
              <span class="text-secondary">{{ category.name }}</span>
            </router-link>
            <span class="text-decoration-none mx-1" v-if="index < product.category.length - 1">/</span>
          </span>
            <p class="mt-3" v-if="product.brand">
              برند:
              <router-link v-if="product.brand" class="text-decoration-none text-secondary"
                           :to="brandLink ? { name: 'Products', query: { page: 1, brand: product.brand.id }, } : '#'"
              >
                <span class="text-secondary text-decoration-none">{{ product.brand.name }}</span>
              </router-link>
              <span v-else class="text-secondary text-decoration-none">{{ product.brand.name }}</span>
            </p>
          </b-col>

          <b-col cols="12" sm="12" md="5">
            <div class="discount custom-z-index"
                 v-if="findAttributeOnSiteInfo('deliver_price')[0] == 0 || product.delivery_amount == 0">
              <h6 class="m-auto">
                ارسال رایگان
              </h6>
            </div>
            <router-link
                :to="{ name: 'Product', params: { name: product.raw_link } }">
              <swiper :options="swiperOptions" class="gallery-top" ref="swiperTop">
                <swiper-slide>
                  <b-img
                      class="pr-2 img-slider"
                      :src="product.thumbnail"
                      :alt="product.name"
                  />
                </swiper-slide>
                <template v-if="product.images.length > 0">
                  <swiper-slide v-for="img in product.images" :key="img.id">
                    <b-img
                        class="pr-2 img-slider"
                        :src="img.file"
                        :alt="product.name"
                    />
                  </swiper-slide>
                </template>
                <div
                    class="swiper-pagination swiper-pagination-bullets"
                    slot="pagination"
                ></div>
              </swiper>
              <swiper :options="swiperOptionThumbs" class="gallery-thumbs" ref="swiperThumbs">
                <swiper-slide>
                  <b-img
                      class="pr-2 img-slider"
                      :src="product.thumbnail"
                      :alt="product.name"
                  />
                </swiper-slide>
                <template v-if="product.images.length > 0">
                  <swiper-slide v-for="img in product.images" :key="img.id">
                    <b-img
                        class="pr-2 img-slider"
                        :src="img.file"
                        :alt="product.name"
                    />
                  </swiper-slide>
                </template>
                <div class="swiper-button-next" slot="button-next"></div>

                <div class="swiper-button-prev" slot="button-prev"></div>
                <div
                    class="swiper-pagination swiper-pagination-bullets"
                    slot="pagination"
                ></div>
              </swiper>
            </router-link>
          </b-col>

          <b-col
              align-self="end"
              cols="12"
              sm="12"
              md="4"
              class="text-center p-3">


            <m-single-product-price-wrapper :digital-shopping-cart-text="digitalShoppingCartText"
                                            :physical-shopping-cart-text="physicalShoppingCartText"
                                            :product="product">
              <template v-slot="{timing,quantity,addToCartFunction,buttonText}">

                <b-col class="text-center " lg="12">
                  <div class="row  ">


                    <div class="col-lg-12" v-if="timing">
                      <div class="col-lg-12" v-if="quantity">
                        <m-single-product-price-1
                            :buttonText="buttonText"
                            :addToCartFunction="addToCartFunction"
                            :product="product"
                        />
                      </div>

                      <div class="w-100" v-else>
                        <m-product-price-100 class="text-dark" :product="product"/>
                        <span class="text-center">موجودی محصول به پایان رسیده است.</span>
                      </div>


                    </div>
                    <div class="w-100" v-else>
                      <m-product-price-100 class="text-dark" :product="product"/>
                      <span class="text-center ">زمان سفارش این محصول به پایان رسیده است.</span>
                    </div>

                  </div>
                </b-col>


              </template>
            </m-single-product-price-wrapper>


          </b-col>


        </b-row>
      </b-container>

      <b-container>
        <b-row class="mt-3">
          <b-tabs class="customize-tab-colors col-lg-12" content-class="border" justified>
            <b-tab active title="مشخصات محصول">
              <div>
                <b-table
                    class="text-right"
                    v-bind="tableAttributes"
                    :fields="fields"
                    :items="tableFeature(product.features)"
                >
                  <template #cell(name)="data">
                    <span>{{ data.item.text }}</span>
                  </template>
                  <template #cell(feature_value)="data">
                    {{ data.item.value }}
                  </template>
                </b-table>
              </div>
            </b-tab>
            <b-tab class="p-4" title="شرح محصول" v-html="processContent(product.description)">
            </b-tab>
          </b-tabs>
        </b-row>
      </b-container>

      <b-container class="my-5 single-product-background-3">
        <m-c4 title="دوره های این محصول" :courses="product.courses"/>
      </b-container>

      <b-container class="my-5 single-product-background-3">
        <m-related-products-301 :title="relatedProductsText" :ignore-product="[product.id]" v-if="relatedProducts"/>
      </b-container>

      <div class="" v-if="comment">
        <m-comment-create-modal-1 :custom_button="false" :commentable_id="product.id" commentable_type="product">
          <template #modal-button>
            <b-button v-b-modal="'create-comment-'+product.id" pill
                      class="col-lg-4">
              ثبت نظر شما
            </b-button>
          </template>
        </m-comment-create-modal-1>
        <m-comments-1 :comment_title="comment_title" :commentable_id="product.id"
                      commentable_type="product"/>
      </div>

    </b-container>
  </m-single-product-wrapper>
</template>

<script>
import {mapGetters} from "vuex";
import {formatNumber} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Converter";
import {tableAttributes} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/TableAttributes";
import TableLayout from "@moeinmdn/mixitweb-front-classic-dashboard/src/plugin/components/dashboard/TableLayout.vue";
import {Swiper, SwiperSlide} from "vue-awesome-swiper";
import "swiper/css/swiper.css";
import {isProductActive} from "@moeinmdn/mixitweb-front-modules/src/plugin/Modules/Timing";
import {basketAddItem, addUnAuthItem} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/ShoppingCartFunctions";

export default {
  name: "SingleProduct1",
  props: {
    productLink: {
      default: null
    },
    relatedProducts: {
      default: false
    },
    digitalShoppingCartText: {
      default: "افزودن به سبد خرید"
    },
    physicalShoppingCartText: {
      default: "افزودن به سبد خرید"
    },
    relatedProductsText: {
      default: "محصولات مرتبط"
    },
    comment: {
      default: true
    },
    comment_title: {
      default: "نظرات"
    },
    categoryLink: {
      default: true
    },
    brandLink: {
      default: true
    },
  },
  components: {
    TableLayout,
    Swiper,
    SwiperSlide,
  },
  data() {
    return {
      tableAttributes: {
        ...tableAttributes,
        ...{class: "text-right", fixed: true},
      },
      fields: [
        {key: "name", label: ""},
        {key: "feature_value", label: ""},
      ],
      swiperOptions: {
        slidesPerView: 1,
        effect: "fade",
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
          dynamicBullets: true,
        },

      },
      swiperOptionThumbs: {
        notNextTick: true,
        spaceBetween: 10,
        centeredSlides: true,
        slidesPerView: 'auto',
        touchRatio: 0.2,
        slideToClickedSlide: true,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      }
    };
  },
  watch: {
    $route: {
      handler() {
        this.$store.dispatch("Product/getProduct", this.$route.params.name);
      },
    },
  },
  computed: {
    ...mapGetters({
      product: "Product/getProduct",
    }),
    IsAuthenticated() {
      return this.$store.getters["User/isAuthenticated"];
    },
    prioductFeatures() {
      const product_features = this.product.features;
      let product_variation = [];


      for (let feature in product_features) {
        feature = product_features[feature]
        // feature.type == 'list' &&  feature.feature_values.sub_product == 1 || feature.type == 'list' && feature.feature_values.sub_product == 0 && feature.feature_values.sub_product


        if (feature.feature_values.sub_product == 0 && feature.feature_values.variation == 0) {

          let feature_attribute_id = feature.feature_values.feature_attribute_id;
          let feature_attributes = feature.feature_attributes

          feature_attributes.forEach(item => {
            if (item.id == feature_attribute_id) {
              product_variation.push({...item, text: feature.name, value: item.value})
            }
          })


        }

      }

      return product_variation
    },
    countProductFeature() {
      let count = 0;
      for (let feature in this.product.features) {
        feature = this.product.features[feature]
        if (feature.feature_values.link_feature_value == null) {
          count = 1;
        } else {
          count = 2;
        }
      }
      return count
    }
  },
  methods: {
    tableFeature(product_features) {
      let product_variation = [];


      for (let feature in product_features) {
        feature = product_features[feature]
        // feature.type == 'list' &&  feature.feature_values.sub_product == 1 || feature.type == 'list' && feature.feature_values.sub_product == 0 && feature.feature_values.sub_product

        if (feature.feature_values.sub_product == 0 && feature.feature_values.variation == 0) {
          let feature_attribute_id = feature.feature_values.feature_attribute_id;
          let feature_attributes = feature.feature_attributes

          if (feature.type == 'text') {
            product_variation.push({text: feature.name, value: feature.feature_values.feature_value})
          }

          if (feature.type == 'list') {
            feature_attributes.forEach(item => {
              if (item.id == feature_attribute_id) {
                product_variation.push({...item, text: feature.name, value: item.value})
              }
            })

          }


        }

      }

      return product_variation
    },
    dataReady(product) {
      this.$nextTick(() => {
        const swiperTop = this.$refs.swiperTop.$swiper
        const swiperThumbs = this.$refs.swiperThumbs.$swiper
        swiperTop.controller.control = swiperThumbs
        swiperThumbs.controller.control = swiperTop
      })
    },
  },
};
</script>

<style>

.customize-tab-colors .nav-item a {
  color: var(--dark) !important;
}
</style>

<style scoped>
.tabs {
  width: 100%;
}

.discount {
  margin: 10px;
  padding: 10px;
  background-color: var(--secondary);
  color: white;
  position: absolute;
  left: 20px;
  top: 7px;
  border-radius: 14px 14px 0px 14px;
  z-index: 10;
}

.img-slider {
  width: 100%;
  object-fit: contain;
  height: 100%;
}

.swiper-slide {
  background-size: cover;
  background-position: center;
  background: white;
}

.gallery-top {
  height: 80% !important;
  width: 100%;
}

.gallery-thumbs {
  height: 20% !important;
  box-sizing: border-box;
  padding: 10px 0;
}

.gallery-thumbs .swiper-slide {
  width: 25%;
  height: 100%;
  opacity: 0.4;
}

.gallery-thumbs .swiper-slide-active {
  opacity: 1;
}
</style>